/**
 * BizCategoryIcon — render a lucide icon by name with a safe fallback.
 * Business categories store the icon as a string (e.g. "Pill", "Tractor")
 * so admins can change them without code edits.
 */
import * as Icons from "lucide-react";

const FALLBACK = Icons.Grid;

export default function BizCategoryIcon({ name, size = 22, className = "", strokeWidth = 2 }) {
    const Comp = (name && Icons[name]) || FALLBACK;
    return <Comp size={size} strokeWidth={strokeWidth} className={className} />;
}
